module.exports = ".error {\n  margin-top: -4px; }\n\np {\n  text-align: left; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\n.line-div {\n  display: block;\n  height: 1px;\n  width: 80%;\n  margin: auto;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  background: #d4d4d4; }\n\ninput,\n.btn {\n  width: 100%; }\n\nselect {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  line-height: 24px;\n  text-align: left;\n  margin-top: 5px; }\n\n.underline {\n  text-decoration: underline; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account/profile/profile.component.scss
// module id = 721
// module chunks = 0